import { render, staticRenderFns } from "./MasterDetail.vue?vue&type=template&id=51928b55&"
import script from "./MasterDetail.vue?vue&type=script&lang=js&"
export * from "./MasterDetail.vue?vue&type=script&lang=js&"
import style0 from "./MasterDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports